var map = {
	"./bg/core": [
		3220,
		220
	],
	"./cs/core": [
		131,
		131
	],
	"./da/core": [
		3321,
		321
	],
	"./de/core": [
		7639,
		639
	],
	"./en/core": [
		3347
	],
	"./es/core": [
		1701,
		701
	],
	"./fr/core": [
		5371,
		371
	],
	"./hu/core": [
		4640,
		640
	],
	"./id/core": [
		5675,
		675
	],
	"./it/core": [
		3681,
		681
	],
	"./ja/core": [
		2152,
		152
	],
	"./ko/core": [
		1649,
		649
	],
	"./nl/core": [
		9,
		9
	],
	"./pl/core": [
		5613,
		613
	],
	"./pt/core": [
		667,
		667
	],
	"./ro/core": [
		8690,
		690
	],
	"./ru/core": [
		5901,
		282
	],
	"./sk/core": [
		1221,
		221
	],
	"./sv/core": [
		779,
		779
	],
	"./tr/core": [
		1615,
		615
	],
	"./ua/core": [
		4984,
		984
	],
	"./uz/core": [
		9287,
		287
	],
	"./zh/core": [
		2980,
		980
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;